// Diff a scanned batch against the set of doc IDs already in the project. The
// server writes those doc IDs from its storage trigger so they're the canonical
// "already uploaded" set — re-dropping the same folder (or re-picking the same
// clips) must not upload anything twice.
//
// SHARED by photo ingest (#323) and the multi-video footage upload behind
// `multiVideoV1`: both derive a stable, content-addressed key client-side and
// both use that key as the Firestore doc id, so one diff answers both. The only
// difference is which field carries the key, which is why `keyOf` is a
// parameter rather than a hard-coded `entry.photoKey`.
//
// Returns:
//   toUpload: entries whose key is NEW to the project
//   alreadyUploaded: entries whose key is already a doc ID
//
// Deliberately does no I/O — the caller fetches existingIds and passes it
// in (one getDocs over the subcollection; we never listen).

// Default reader keeps every existing photo call site byte-identical.
export const photoKeyOf = (entry) => entry?.photoKey;
export const videoKeyOf = (entry) => entry?.videoKey;

export function diffAgainstExisting(entries, existingIdSet, { keyOf = photoKeyOf } = {}) {
  const set = existingIdSet instanceof Set
    ? existingIdSet
    : new Set(Array.isArray(existingIdSet) ? existingIdSet : []);
  const toUpload = [];
  const alreadyUploaded = [];
  for (const entry of entries || []) {
    if (set.has(keyOf(entry))) {
      alreadyUploaded.push(entry);
    } else {
      toUpload.push(entry);
    }
  }
  return {
    toUpload,
    alreadyUploaded,
    // Handy pre-summed totals used in the preflight modal.
    totals: {
      toUploadCount: toUpload.length,
      toUploadBytes: toUpload.reduce((a, e) => a + (e.sizeBytes || 0), 0),
      alreadyUploadedCount: alreadyUploaded.length,
    },
  };
}
